import React from 'react';
import ManageWedding from "./ManageWedding"

const PagesCreate = () => {
    return (
         <div className={"p-lg-4 ps-4 pt-5 mx-auto w-80vw"}>
            <div className={"flex"}>
                <ManageWedding id={"0"}/>
            </div>
        </div>
    );
};

export default PagesCreate;
